module.exports = "<iframe [src]=\"source\" class=\"ssrs-reportviewer\" [style.width.%]=\"width\" [style.height.%]=\"height\" scrolling=\"yes\">\n"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/report-viewer/report-viewer.component.html
// module id = ../../../../../src/app/shared/component/report-viewer/report-viewer.component.html
// module chunks = main